"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _classnames = _interopRequireDefault(require("classnames"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _reactOnclickoutside = _interopRequireDefault(require("react-onclickoutside"));

var _SearchInput = _interopRequireDefault(require("./SearchInput"));

var _focus = require("./utils/focus");

var _OptionList = _interopRequireDefault(require("../Select/OptionList/OptionList"));

var _AutocompleteInput = _interopRequireDefault(require("./AutocompleteInput.style"));

var ARROW_DOWN = 40;
var ARROW_UP = 38;
var ENTER = 13;
var keyCodes = [ARROW_DOWN, ARROW_UP, ENTER];
var SELECTION_TYPE = {
  SELECTED: 'selected',
  FOCUSED: 'focused'
};

var AutocompleteInput =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(AutocompleteInput, _React$Component);

  function AutocompleteInput(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AutocompleteInput);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AutocompleteInput).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleClickOutside", function () {
      _this.setState({
        expanded: false,
        focused: 0
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleOptionHover", function (_ref) {
      var target = _ref.target;
      if (target.disabled) return;

      _this.setState({
        focused: +target.dataset.index
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleOptionClick", function (option) {
      _this.setState({
        expanded: false
      });

      _this.props.onSelect(option);

      _this.setSearchValue(option, SELECTION_TYPE.SELECTED);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "searchChangeCallback", function (searchText) {
      _this.props.onSearch(searchText);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onSearchChange", function (e) {
      var options = _this.props.options;

      _this.searchChangeCallback(e.target.value);

      var value = e.target.value;

      _this.setState({
        searchValue: value,
        expanded: !!value,
        focused: (0, _focus.nextFocus)(options, -1)
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setSearchValue", function (option, selectionType) {
      var clearOnSelect = _this.props.clearOnSelect;
      var isSelected = selectionType === SELECTION_TYPE.SELECTED;

      if (isSelected && clearOnSelect) {
        _this.setState({
          searchValue: ''
        });

        return;
      }

      var label = option && option.label;

      _this.setState({
        searchValue: label
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleEnter", function () {
      var _this$state = _this.state,
          focused = _this$state.focused,
          expanded = _this$state.expanded;
      var options = _this.props.options;
      if (!expanded) return;
      var option = options[focused];
      if (!option) return;

      _this.handleOptionClick(option);

      _this.setState({
        expanded: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleKeyDown", function (e) {
      if (!keyCodes.includes(e.keyCode) || !_this.state.expanded) return;
      e.preventDefault();
      var keyCode = e.keyCode,
          target = e.target;

      if (keyCode === ENTER) {
        _this.handleEnter(target);
      } else {
        _this.setState(function (_ref2, _ref3) {
          var focused = _ref2.focused;
          var options = _ref3.options;
          return {
            focused: keyCode === ARROW_UP ? (0, _focus.prevFocus)(options, focused) : (0, _focus.nextFocus)(options, focused)
          };
        }, function () {
          var options = _this.props.options;
          var focused = _this.state.focused;

          _this.setSearchValue(options[focused], SELECTION_TYPE.FOCUSED);
        });
      }
    });

    if (props.searchCallbackDelay > 0) {
      _this.searchChangeCallback = (0, _debounce.default)(_this.searchChangeCallback, props.searchCallbackDelay);
    }

    _this.state = {
      searchValue: '',
      expanded: false,
      focused: 0
    };
    return _this;
  }

  (0, _createClass2.default)(AutocompleteInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          autoCompleteInputWrapperProps = _this$props.autoCompleteInputWrapperProps,
          options = _this$props.options,
          loading = _this$props.loading,
          customOption = _this$props.customOption,
          notFoundOption = _this$props.notFoundOption,
          searchInputProps = _this$props.searchInputProps;
      var _this$state2 = this.state,
          expanded = _this$state2.expanded,
          searchValue = _this$state2.searchValue,
          focused = _this$state2.focused;
      return _react.default.createElement("div", (0, _extends2.default)({}, autoCompleteInputWrapperProps, {
        onKeyDown: this.handleKeyDown,
        role: "presentation",
        className: (0, _classnames.default)(autoCompleteInputWrapperProps.className, _AutocompleteInput.default.div)
      }), _react.default.createElement(_SearchInput.default, (0, _extends2.default)({}, searchInputProps, {
        value: searchValue,
        onChange: this.onSearchChange
      })), expanded && _react.default.createElement(_OptionList.default, {
        options: options,
        handleOptionClick: this.handleOptionClick,
        customOption: customOption,
        focused: focused,
        handleOptionHover: this.handleOptionHover,
        loading: loading,
        selectedOptions: [],
        notFoundOption: notFoundOption
      }));
    }
  }]);
  return AutocompleteInput;
}(_react.default.Component);

AutocompleteInput.defaultProps = {
  autoCompleteInputWrapperProps: {},
  options: [],
  onSelect: function onSelect() {},
  searchCallbackDelay: 0,
  onSearch: function onSearch() {},
  customOption: undefined,
  loading: false,
  searchInputProps: {},
  notFoundOption: undefined,
  clearOnSelect: false
};
AutocompleteInput.propTypes = {
  autoCompleteInputWrapperProps: _propTypes.default.shape({}),
  options: _propTypes.default.array,
  onSelect: _propTypes.default.func,
  searchCallbackDelay: _propTypes.default.number,
  onSearch: _propTypes.default.func,
  customOption: _propTypes.default.func,
  loading: _propTypes.default.bool,
  searchInputProps: _propTypes.default.object,
  notFoundOption: _propTypes.default.object,
  clearOnSelect: _propTypes.default.bool
};

var _default = (0, _emotionTheming.withTheme)((0, _reactOnclickoutside.default)(AutocompleteInput));

exports.default = _default;